import Dot from './Dot'

export default Dot
// eslint-disable-next-line import/export
export * from './Dot'
